import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export function useReminderBarHidden(
  buttonText: string,
  hidable: boolean,
  hiddenOnPages: string[] = []
) {
  const location = useLocation();

  const storageKey = `reminderBar_${buttonText
    .toLowerCase()
    .replace(/\s+/g, '_')}`;

  const [hidden, setHidden] = useState(() => {
    if (!hidable) return false;
    return sessionStorage.getItem(storageKey) === 'true';
  });

  const handleDismiss = () => {
    setHidden(true);
    sessionStorage.setItem(storageKey, 'true');
  };

  const shouldHideOnPage = hiddenOnPages.some((path) =>
    location.pathname.includes(path)
  );

  return {
    hidden: shouldHideOnPage || hidden,
    handleDismiss,
  };
}
